import { isLocalhost } from './functionsHelpers';
import {getLabel} from "../i18n";

export const getGoogleMapsApiKey = function () {
    return isLocalhost
        ? process.env.REACT_APP_GOOGLE_MAPS_API_KEY_DEV
        : process.env.REACT_APP_GOOGLE_MAPS_API_KEY_PROD;
};

export const getI18nGeoError = function ({ code }) {
    if (!!window?.GeolocationPositionError) {
        switch (code) {
            case window.GeolocationPositionError.PERMISSION_DENIED:
                return getLabel('geolocation_error_denied');
            case window.GeolocationPositionError.POSITION_UNAVAILABLE:
            case window.GeolocationPositionError.TIMEOUT:
                return getLabel('geolocation_error_unavailable');
        }
    }

    return getLabel('geolocation_error_default');
};

export const getGeolocation = async function () {
    return new Promise((resolve, reject) => {
        try {
            if (!navigator.geolocation) throw 'Geolocation is not supported by your browser';

            const options = {
                maximumAge: 30 * 60 * 1000, // mise en cache de 30min
                timeout: 10 * 1000, // timeout au bout de 10s
            };
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve(position);
                },
                (error) => {
                    reject(error);
                },
                options,
            );
        } catch (e) {
            throw e;
        }
    });
};

export const getGeocodedAddress = async function (position) {
    try {
        if (!position?.coords) throw 'Position is missing';
        if (!window.google?.maps?.Geocoder) throw 'Geocoder is unavailable';

        const location = { lat: position.coords.latitude, lng: position.coords.longitude };
        const geocoder = new window.google.maps.Geocoder();
        const response = await geocoder.geocode({ location });

        if (!response?.results?.length) {
            throw 'Geocoder failed due to: no results';
        }

        const res = response.results[0];

        if (res?.address_components?.length) {
            const postcode = res?.address_components.find((i) =>
                i?.types.includes('postal_code'),
            )?.long_name;
            const city = res?.address_components.find((i) =>
                i?.types.includes('locality'),
            )?.long_name;
            const country_code = res?.address_components.find((i) =>
                i?.types.includes('country'),
            )?.short_name;

            return { postcode, city, country_code };
        }

        return null;
    } catch (e) {
        throw 'Geocoder address unavailable';
    }
};
